import { PropsWithChildren } from 'react';
import { format, formatDistance, subDays, isBefore } from 'date-fns';
import locale from 'date-fns/locale/es';

const RELATIVE_FROM_DAYS = 15;
const DISPLAY_FORMAT = 'dd/MM/yyyy';
const LONG_FORMAT = 'PPpp';

type DateDisplayProps = {
  format?: string,
  relative?: boolean
}

export function formatDate(date: Date, {format : dateFormat, relative} : DateDisplayProps) {
  const now = new Date();
  const fmt = dateFormat || DISPLAY_FORMAT;

  const showRelative = relative && !isBefore(date, subDays(now, RELATIVE_FROM_DAYS));
  return showRelative ? formatDistance(date, now, { locale, addSuffix: true }) : format(date, fmt, { locale });
}

const DateDisplay = ({ format: dateFormat, relative, children } : PropsWithChildren<DateDisplayProps>) => {
  const date = new Date(children as number);
  const display = formatDate(date, { format: dateFormat, relative });
  const title = format(date, LONG_FORMAT, { locale });

  return <span title={title}>{display}</span>
};

export default DateDisplay;